export default __webpack_public_path__ + "static/media/edit_teacher.8b8887cb.svg";